import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_CLIENTS_PROJECTS_RESET } from '../../../redux/constantes/clientsProjects';
import {
  SearchSpecifyClientsProjectsAction,
  UpdateClientsProjectsAction,
} from '../../../redux/actions/clientsProjects';

import { ContainerForm } from '../../../components/Containers';
import InputCompany from '../../../components/Company/InputCompany';
import InputIsActive from '../../../components/Company/InputIsActive';
import ButtonSend from '../../../components/ButtonSend';
import ButtonBack from '../../../components/ButtonBack';
import { WrapperButtons } from '../../../components/Company/WrapperButtons';
import { MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox';
import HeaderTitle from '../../../components/HeaderTitle';
import SelectCompanySincroniza from '../../../components/SincronizaNFe/SelectCompanySincroniza';

export default function TemplateEditClientsProjectsAndCompanies({ clientProjectId }) {
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [errorCompany, setErrorCompany] = useState(false);

  const { specifyClientProject, error: errorSearchSpecifyClientsProjects } = useSelector(
    (state) => state.searchSpecifyClientsProjects,
  );
  const { success: successUpdate, error: errorUpdate } = useSelector((state) => state.updateClientsProjects);
  const dispatch = useDispatch();

  useEffect(() => {
    if (errorSearchSpecifyClientsProjects === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [errorSearchSpecifyClientsProjects]);

  useEffect(() => {
    if (!specifyClientProject) {
      dispatch(SearchSpecifyClientsProjectsAction(clientProjectId));
    } else {
      setName(specifyClientProject.name);
      setCompany(specifyClientProject.company);
      setCnpj(specifyClientProject.cnpj);
      setIsActive(specifyClientProject.isActive);
    }
  }, [dispatch, clientProjectId, specifyClientProject]);

  useEffect(() => {
    if (successUpdate) {
      setTimeout(() => {
        dispatch({ type: UPDATE_CLIENTS_PROJECTS_RESET });
        document.location.href = '/sincroniza-nfe/registro-cliente-projeto-empresa';
      }, 2000);
    }
    if (errorUpdate) {
      setTimeout(() => {
        dispatch({ type: UPDATE_CLIENTS_PROJECTS_RESET });
      }, 3000);
    }
  }, [successUpdate, dispatch, errorUpdate]);

  const handleSubmit = () => {
    dispatch(UpdateClientsProjectsAction(clientProjectId, name, company, cnpj, isActive));
  };

  return (
    <ContainerForm>
      <HeaderTitle text="Editar Cliente | Projeto | Empresa" linkIcon="/images/icons/configuration2.svg" />
      <InputCompany
        id="name"
        label="Nome do Cliente - Projeto"
        type="text"
        onChange={(e) => setName(e.target.value)}
        value={name}
        placeholder="Exemplo: Abeaço-Ed. Ambiental-2021"
      />
      <SelectCompanySincroniza setErrorCompany={setErrorCompany} setCompany={setCompany} value={company} />
      <InputIsActive isActive={isActive} setIsActive={setIsActive} />
      <WrapperButtons>
        <ButtonBack text="Voltar" path="/sincroniza-nfe/registro-cliente-projeto-empresa" />
        <ButtonSend onClick={handleSubmit}>Atualizar</ButtonSend>
      </WrapperButtons>
      {successUpdate && <MessageBoxSuccess>Dados atualizados com sucesso!</MessageBoxSuccess>}
      {errorUpdate && <MessageBoxError>{errorUpdate}</MessageBoxError>}
      {errorSearchSpecifyClientsProjects && <MessageBoxError>{errorSearchSpecifyClientsProjects}</MessageBoxError>}
      {errorCompany && <MessageBoxError>Ops... Você não escolheu empresa!</MessageBoxError>}
    </ContainerForm>
  );
}
